import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Logo from "Assets/Images/logoTeste.png";
import ArticlesHome from "Components/Home/ArticlesHome";
import Popup from "Components/Popup";
import api from "Helpers/Api";
import Routes from "Routes";
import { TBannerResponse } from "Services/Banners/banner";
import { TCampaign } from "Services/Campaigns/campaigns";
import { sections } from "Views/Articles/Home";
import CarouselStore from "Views/Stores/List/CarouselStore";
import * as Styled from "./styles";

const CarouselStoreBanners: React.FC = () => {
  const [banners, setBanners] = useState<TBannerResponse[]>([]);
  const [popup, setPopup] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const mobile = window.innerWidth <= 1023; // Check if it's mobile

  const getBanner = async () => {
    try {
      const response = await api.get<TBannerResponse[]>("/banners/active");
      const dataFilter = response.data.filter(e => e.position === "meio_home");
      setBanners(dataFilter);
    } catch (error) {
      setBanners([]);
    }
    try {
      const response = await api.get<TCampaign[]>(`/campaign/list/popup`);
      let popArray = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let x = 0; x < response.data[i].images.length; x++) {
          popArray.push({
            image: response.data[i].images[x].image_url,
            title: response.data[i].campaign_name || "",
            description: response.data[i].campaign_description || "",
            link: response.data[i].redirect_link,
          });
        }
      }
      if (popArray.length > 0) {
        setPopup(popArray);
        setIsModalOpen(true);
      }
    } catch (error) {
      setPopup([]);
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <>
      <Styled.Container>
        <CarouselStore
          slides={
            banners.length > 0
              ? banners
              : [
                  {
                    image: Logo,
                    title: "Publicidade no RURAX",
                    description:
                      "Aumente suas vendas, seja descoberto pelo mercado do Agronegócio através do Sistema de Recomendação do RURAX.",
                    link: "/login",
                  },
                ]
          }
          isSponsored={false}
        />
      </Styled.Container>
    </>
  );
};

const SeparetedHome: React.FC = () => {
  const history = useHistory();
  const [banners, setBanners] = useState<TBannerResponse[]>([]);
  const [popup, setPopup] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const mobile = window.innerWidth <= 1023; // Check if it's mobile

  const getBanner = async () => {
    try {
      const response = await api.get<TBannerResponse[]>("/banners/active");
      const dataFilter = response.data.filter(e => e.position === "meio_home");
      setBanners(dataFilter);
    } catch (error) {
      setBanners([]);
    }
    try {
      const response = await api.get<TCampaign[]>(`/campaign/list/popup`);
      let popArray = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let x = 0; x < response.data[i].images.length; x++) {
          popArray.push({
            image: response.data[i].images[x].image_url,
            title: response.data[i].campaign_name || "",
            description: response.data[i].campaign_description || "",
            link: response.data[i].redirect_link,
          });
        }
      }
      if (popArray.length > 0) {
        setPopup(popArray);
        setIsModalOpen(true);
      }
    } catch (error) {
      setPopup([]);
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <>
      <Styled.Container id="separated-home">
        {/* <Styled.TopBanner>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%"
            }}
          >
            <Styled.PersonalCard src={PersonalCard} />
            <Styled.TopBannerText>Fique atento</Styled.TopBannerText>
          </div>
        </Styled.TopBanner> */}
        <Styled.Content>
          <ArticlesHome
            link={Routes.articles.replace(":category?", "")}
            section={{ ...sections[0], title: "Notícias" }}
            perPage={6}
          />
        </Styled.Content>
        {/* <Styled.MiddleBanner>
          <Styled.CategoryMiddleBanner>Tecnologia</Styled.CategoryMiddleBanner>
          <Styled.TitleMiddleBanner>
            Tecnologia no campo: você está preparado?
          </Styled.TitleMiddleBanner>
          <Styled.SubTitleMiddleBanner>
            A tecnologia no campo é uma realidade e quem não se adaptar, ficará
            para trás.
          </Styled.SubTitleMiddleBanner>
          <Styled.BtnReadMoreMiddleBanner>
            <ButtonPrimary
              type="button"
              color="green"
              action={() => history.push("/tecnologia-no-campo")}
              borderRadius="6px"
            >
              Saiba mais
            </ButtonPrimary>
          </Styled.BtnReadMoreMiddleBanner>
        </Styled.MiddleBanner> */}
        {!mobile && <CarouselStoreBanners />}
      </Styled.Container>
      {/* <HomeMenu /> */}

      {/* PopUp Banner */}
      {isModalOpen && popup.length > 0 && (
        <Popup
          time={30000}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <Styled.ContainerPop id="popup">
            <CarouselStore slides={popup} isPopUp={true} />
          </Styled.ContainerPop>
        </Popup>
      )}
    </>
  );
};

export { CarouselStoreBanners };
export default SeparetedHome;
